import type { IconProps } from './IconProps';

export const ArrowRightLarge = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    {...props}
  >
    <path
      d="M5.5 12.5H19.5M19.5 12.5L12.5 5.5M19.5 12.5L12.5 19.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
